var map = {
	"./banner": [
		"354e"
	],
	"./banner.vue": [
		"354e"
	],
	"./chat-item": [
		"59ce",
		"chunk-0ce08a52"
	],
	"./chat-item.vue": [
		"59ce",
		"chunk-0ce08a52"
	],
	"./footer": [
		"8416"
	],
	"./footer.vue": [
		"8416"
	],
	"./header": [
		"7a54"
	],
	"./header.vue": [
		"7a54"
	],
	"./live-info": [
		"4158"
	],
	"./live-info.vue": [
		"4158"
	],
	"./schedule": [
		"096f",
		"chunk-5b708c8b"
	],
	"./schedule.vue": [
		"096f",
		"chunk-5b708c8b"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "5a1c";
module.exports = webpackAsyncContext;